import React from 'react';

const h = React.createElement;

/**
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {React.CSSProperties} [p.style]
 */
export function CardFooter({ children, style }) { return h('div', { style: { display: 'flex', alignItems: 'center', gap: 10, marginTop: 'var(--stack-gap)', paddingTop: 12, borderTop: '1.5px solid var(--line)', fontSize: 12, color: 'var(--mut2)', ...style } }, children); }
